import { refreshAppts } from "./refetch-appt";

declare global {
  interface Window {
    refreshTodayAppts: (props: { clinicId: string }) => Promise<boolean>;
  }
}
export function exposeBridgeFunctions() {
  window.refreshTodayAppts = refreshAppts;
}
